import React from 'react';
import { Form, Button, Skeleton, Input, Radio, Space, DatePicker, Spin, message, Select } from 'antd';
import { navigate } from "@reach/router"
import { LoadingOutlined } from '@ant-design/icons';
import { API, graphqlOperation, Storage } from 'aws-amplify';
import * as queries from '../graphql/queries'
import * as mutations from '../graphql/mutations'
import UploadFiles from './upload'
import moment from 'moment'

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />
const { TextArea } = Input;

const getSimpleInput = (props) => {
    const { name, label, isReq, msg, rules } = props
    // <Form.Item label="Jméno a příjmení" name="name" rules={[{ required: true, message: 'Prosím, vyplň jméno.' }]}>
    return (<Form.Item name={name} label={label} rules={[{ required: isReq || false, message: msg || 'Povinné pole' }, ...(rules || [])]}>
        <Input />
    </Form.Item>)
}

const normFile = (e) => {
    console.log('Upload event:', e);
    if (Array.isArray(e)) {
        return e;
    }
    return e && e.fileList;
};

const uniYearValues = ["1. ročník Bc.", "2. ročník Bc.", "3. ročník Bc.", "1. ročník Ing./Mgr.", "2. ročník Ing./Mgr."]

function LinkifyText(text) {
    if (typeof text !== "string") return <>{text ?? ""}</>;

    const URL_RE = /((https?:\/\/|www\.)[^\s<>"']+)/g;
    const TRAIL = /[.,!?;:)\]]+$/;

    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = URL_RE.exec(text)) !== null) {
        const raw = match[0];
        const cleanDisplayed = raw.replace(TRAIL, "");
        const suffix = raw.slice(cleanDisplayed.length);
        const href = cleanDisplayed.startsWith("http")
            ? cleanDisplayed
            : `http://${cleanDisplayed}`;

        if (match.index > lastIndex) parts.push(text.slice(lastIndex, match.index));

        parts.push(
            <a
                key={`lnk-${parts.length}`}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ wordBreak: "break-word" }}
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
            >
                {cleanDisplayed}
            </a>
        );

        if (suffix) parts.push(suffix);
        lastIndex = match.index + raw.length;
    }

    if (lastIndex < text.length) parts.push(text.slice(lastIndex));

    return (
        <span style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>
            {parts.map((p, i) => (
                <React.Fragment key={i}>{p}</React.Fragment>
            ))}
        </span>
    );
}

function ShowUniYearOptions(props) {
    const [value, setValue] = React.useState(null)

    return (<>
        <Form.Item
            name="uniYearEnrolled"
            label="V jakém jsi ročníku?"
            rules={[{ required: true, message: 'Prosím, vyber ročník, případně rok dokončení studia' }]}

        >
            <Radio.Group value={value} onChange={(e) => setValue(e.target.value)}>
                <Space direction="vertical">
                    {[...Array(5).keys()].map(el => { return (<Radio value={uniYearValues[el]}>{`${uniYearValues[el]}`}</Radio>) })}
                    <Radio value={'graduated'}>Studium dokončeno</Radio>
                    <Radio value={'other'}>Jiný</Radio>
                </Space>
            </Radio.Group>
        </Form.Item>
        <Form.Item shouldUpdate={(prevValues, curValues) => prevValues.uniYearEnrolled !== curValues.uniYearEnrolled} noStyle>
            {() => {
                if (value == 'graduated') {
                    return (
                        <Form.Item name="graduated-year" label="V jakém roce jsi dokončil/a studium?" rules={[{ required: true, message: 'Prosím, vyber rok dokončení studia' }]}
                        >
                            <Input placeholder="V jakém roce jsi dokončil/a studium?" style={{ width: 300 }} />
                            {/* <DatePicker picker="year" placeholder="Vyber rok ukončení studia" style={{ width: 300 }} /> */}
                        </Form.Item>
                    )

                }
                if (value == 'other') {
                    return (
                        <Form.Item name="graduated-other" label="Jiný" rules={[{ required: true, message: 'Prosím, popiš svůj studijní stav' }]}
                        >
                            <Input placeholder="Prosím, popiš svůj studijní stav" style={{ width: 300 }} />
                            {/* <DatePicker picker="year" placeholder="Vyber rok ukončení studia" style={{ width: 300 }} /> */}
                        </Form.Item>
                    )

                }

            }}
        </Form.Item></>
    )
}

function ShowUniOptions(props) {
    const [value, setValue] = React.useState(null)
    const unis = [
        { value: "czu", label: "Česká zemědělská univerzita v Praze" },
        { value: "cvut", label: "České vysoké učení technické v Praze" },

        { value: "jcu", label: "Jihočeská univerzita v Českých Budějovicích" },
        
        { value: "masaryk", label: "Masarykova univerzita v Brně" },
        { value: "mendel", label: "Mendelova univerzita v Brně" },

        { value: "ostrava", label: "Ostravská univerzita" },

        { value: "techlib", label: "Technická univerzita v Liberci" },

        { value: "uhk", label: "Univerzita Hradec Králové" },
        { value: "cuni", label: "Univerzita Karlova v Praze" },
        { value: "pardubice", label: "Univerzita Pardubice" },

        { value: "banska", label: "Vysoká škola Báňská – Technická univerzita Ostrava" },
        { value: "vscht", label: "Vysoká škola chemicko-technologická v Praze" },
        { value: "vse", label: "Vysoká škola ekonomická v Praze" },
        { value: "vut", label: "Vysoké učení technické v Brně" },

        { value: "other", label: "Jiná" }
    ]


    return (
        <>
            <Form.Item
                name="uniEnrolled"
                label="Jakou školu studuješ?"
                rules={[{ required: true, message: 'Prosím, vyber univerzitu' }]}
            >
                <Radio.Group value={value} onChange={(e) => setValue(e.target.value)}>
                    <Space direction="vertical">
                        {unis.map(el => { return (<Radio value={el.value}>{el.label}</Radio>) })}
                    </Space>
                </Radio.Group>
            </Form.Item>
            <Form.Item noStyle shouldUpdate={(prevValues, curValues) => prevValues.uniEnrolled !== curValues.uniEnrolled}>
                {({ getFieldValue }) => {
                    const uniSelected = getFieldValue("uniEnrolled")
                    if (uniSelected == 'other') {
                        return (
                            <Form.Item
                                name='uni-other'
                                label="Vyplň svoji univerzitu"
                                rules={[{ required: true, message: 'Prosím, napiš, jakou studuješ univerzitu.' }]}
                                style={{ marginTop: -10 }}
                            >
                                <Input style={{ width: 350 }} />
                            </Form.Item>

                        )
                    } else {
                        return (null)
                    }
                }}
            </Form.Item>

        </>
    )
}

const testInitVals = {
    "name": "jon",
    "surname": "doe",
    "email": "test@test.cz",
    "uniEnrolled": "cvut",
    "uniFaculty": "sda",
    "uniCourse": "dasd",
    "uniYearEnrolled": "1. ročník Bc.",
    "linkedin": "lnkd",
    "phone": "+420123456789",
    files: []
}


export default function Event(props) {
    // console.log('event props', props)
    const { eventID } = props
    const [form] = Form.useForm();


    const [isLoading, setIsLoading] = React.useState(true)
    const [isSubmitting, setIsSubmitting] = React.useState(false)
    const [spinnerText, setSpinnerText] = React.useState("")
    const [eventData, setEventData] = React.useState(null)


    const onFinish = async ({ values }) => {
        // console.log('on - finish:', values);
        // console.log(eventData)
        setIsSubmitting(true)
        setSpinnerText("Registruji přihlášku...")
        let updatedVals = {
            ...values, multiCh: [], custQ: [], eventsVersion: 'v2',
            filesBucket: `${Storage._config.AWSS3.bucket}`
        }
        const answers = values.answers ?? []
        // add questions to payload
        eventData.multiChoicesQuestions.forEach(
            (mChQ, idx) => {
                updatedVals = {
                    ...updatedVals,
                    multiCh: [...updatedVals.multiCh, {
                        question: mChQ.question,
                        answer: values[`multChQ${idx}`] || null
                    }]
                }
            }
        )
        eventData.questions.forEach(
            (q, idx) => {
                updatedVals = {
                    ...updatedVals,
                    custQ: [...updatedVals.custQ, {
                        question: q,
                        answer: answers[idx] ?? null
                    }]
                }
            }
        )

        try {
            const resp = await API.graphql(graphqlOperation(mutations.recordResponse, { input: { id: eventID, response: JSON.stringify(updatedVals) } }))
            console.log(resp)
            setIsSubmitting(false)
            if (window.gtag) {
                window.gtag('event', 'conversion', { 'send_to': 'AW-852971816/4izZCMemgIIcEKii3ZYD' });
            }
            if (window.fbq) {
                window.fbq('track', 'Lead');
            }
            if (window.lintrk) {
                window.lintrk('track', { conversion_id: 26723705 });
            }
            return (navigate(`/thanks/${eventData.thankyou}/${eventData.eventName}`))
        } catch (err) {
            console.error(err)
        }
        setIsSubmitting(false)
    };


    React.useEffect(() => {
        if (isLoading) {
            const fetchData = async () => {
                // console.log('fetching data')
                try {
                    const resp = await API.graphql(graphqlOperation(queries.getEvent, { id: eventID }))
                    // console.log(resp)
                    const dt = JSON.parse(resp.data.getEvent.payload)

                    if (moment().utc().isSameOrAfter(moment(dt.eventSignupEnd || null)) || moment().utc().isSameOrAfter(moment(dt.eventStart))) {
                        return (navigate(`/events/pastDeadline/${dt.eventName}`))
                    }
                    setEventData(
                        {
                            ...dt,
                            questions: dt.questions || [],
                            multiChoicesQuestions: dt.multiChoicesQuestions || [],
                            blocksOrder: dt.blocksOrder || ['primaryBlock', 'questions', 'multiChoicesQuestions', 'files']
                        }
                    )

                } catch (err) {
                    console.error(err)
                    message.error('Neznámá událost')
                }
                setIsLoading(false)
            }
            fetchData()
        }
    }, [isLoading])

    if (isLoading) { return (<Skeleton active />) }

    if (eventData != null) {


        return (

            <div className='form-container'>

                <div className='form-header'>

                    <div className="event-label-container">
                        <span className="event-label" >
                            {eventData.eventName}
                        </span>
                    </div>
                </div>
                <div className='event-form-container'>

                    <Spin spinning={isSubmitting} indicator={antIcon} size="large" tip={spinnerText}>
                        <Form
                            name="basic"
                            form={form}

                            labelCol={{
                                span: 24,
                            }}
                            wrapperCol={{
                                span: 24,
                            }}
                            initialValues={window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" ? testInitVals : { files: [], answers: [] }}
                            onFinish={async (vls) => await onFinish({ values: vls })}

                            autoComplete="off"
                            layout="vertical"
                        >

                            {/* for dev, display data if necessary */}
                            {/* {JSON.stringify(eventData, null, 2)} */}

                            {/* dynamic blocks*/}
                            {
                                eventData.blocksOrder.map((block) => {
                                    switch (block) {
                                        case 'questions':
                                            return renderQuestions(eventData)
                                        case 'multiChoicesQuestions':
                                            return renderMultiQuestions(eventData)
                                        case 'files':
                                            return renderFiles(eventData, form, eventID, setIsSubmitting, setSpinnerText)
                                        case 'primaryBlock':
                                            return renderPrimaryBlock(eventData)
                                        default:
                                            return null
                                    }
                                }
                                )
                            }

                            <Button type="primary" htmlType="submit" size="large" loading={isSubmitting} style={{ backgroundColor: 'rgb(255, 230, 0)', color: 'rgb(25, 25, 32)', borderWidth: 0 }}>
                                Odeslat
                            </Button>
                        </Form>
                    </Spin>
                </div >

            </div >
        )
    }
}


const renderQuestions = (eventData) => {
    if (!eventData.questions || eventData.questions.length === 0) { return null }

    return (
        <Form.List name="answers">
            {(fields) => eventData.questions.map((question, qidx) => {
                const field = fields[qidx] || { key: qidx, name: qidx, fieldKey: qidx, isListField: true };
                const { key, name, ...restField } = field;

                return (
                    <Form.Item
                        className="linkable-label"
                        key={key}
                        name={name}
                        {...restField}
                        label={LinkifyText(question)}
                        rules={[{ required: eventData.questionsRequired?.[qidx] || false, message: 'Prosím, vyplň toto pole.' }]}
                    >
                        <TextArea rows={eventData.answersLong?.[qidx] ? 3 : 1} />
                    </Form.Item>
                )
            })}
        </Form.List>
    )
}

const renderMultiQuestions = (eventData) => {
    return (eventData.multiChoicesQuestions ? <>
        {eventData.multiChoicesQuestions.map((multChQ, idx) => {
            return (
                <Form.Item
                    key={`multChQ${idx}`}
                    name={`multChQ${idx}`}
                    label={LinkifyText(multChQ.question)}
                    rules={[{ required: multChQ.required, message: 'Vyplň, prosím, tuto otázku.' }]}

                >{multChQ.multiChoiceAllowed ?
                    <Select mode="multiple">
                        {multChQ.options.map((opt, idx) =>
                            <Select.Option key={`a${idx}`} value={opt}>{opt}</Select.Option>
                        )}
                    </Select>
                    :
                    <Radio.Group >
                        <Space direction="vertical">
                            {multChQ.options.map((opt, idx) =>
                                <Radio key={`b${idx}`} value={opt}>{opt}</Radio>
                            )}
                        </Space>
                    </Radio.Group>
                    }
                </Form.Item>
            )
        })}
        {/* {JSON.stringify(eventData.multiChoicesQuestions)} */}
    </> : null)
}

const renderFiles = (eventData, form, eventID, setIsSubmitting, setSpinnerText) => {

    return (
        eventData.showUploadFiles ?
            <>

                <Form.Item name="files"
                    label={eventData.showUploadFilesLabel || "Nahraj soubory"}
                    // valuePropName="fileList"
                    // getValueFromEvent={normFile}
                    rules={[{ required: eventData.showUploadFilesRequired || false, message: 'Prosím, nahraj soubory.' }]}
                >
                    <UploadFiles form={form} eventID={eventID} spinOn={setIsSubmitting} setSpinnerText={setSpinnerText} />
                </Form.Item>
            </>
            : null
    )

}

const renderPrimaryBlock = (eventData) => {
    return (
        <>
            {getSimpleInput({ name: "name", label: "Jméno", isReq: true })}
            {getSimpleInput({ name: "surname", label: "Příjmení", isReq: true })}
            {getSimpleInput({ name: "email", label: "Kontaktní email", isReq: true, rules: [{ 'type': 'email' }] })}
            {
                eventData.showPhone ? getSimpleInput({
                    name: "phone", label: "Kontaktní telefon", isReq: true, rules: [
                        {
                            required: true,
                            pattern: /^\+\d{1,3}\d{7,13}$/,
                            message: "Zadej prosím telefon v mezinárodním formátu, např. +420123456789.",
                        }
                    ]
                }) : null
            }
            {eventData.showUniOptions ? <ShowUniOptions /> : null}
            {eventData.showFacultyOptions ? getSimpleInput({ name: "uniFaculty", label: "Na jaké fakultě?", isReq: true }) : null}
            {eventData.showCourseOptions ? getSimpleInput({ name: "uniCourse", label: "Jaký obor?", isReq: true }) : null}
            {eventData.showYearOptions ? <ShowUniYearOptions /> : null}
        </>
    )

}
